import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  Cross,
  InputField,
} from '@cashfree-intl/coherent';
import FormikComponent from 'components/Formik';
import { validationSchema } from '../helpers';

export function AddPopup({ onCloseClick, onSubmit, info }) {
  return (
    <Modal className="common-modal-wrapper webhook-modal" open>
      <ModalHeader>
        <div>
          <div className="heading">Add New Preference</div>
        </div>
        <div className="close-modal">
          <Cross
            data-event-name="Form_AddNewPreferenceModal_Icon_Close"
            data-ignore-inner-text="true"
            onClick={onCloseClick}
          />
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="modal-content">
          <FormikComponent
            // @ts-ignore
            initialValues={{
              categoryValue: info.category,
              preferenceValue: info.preference,
              emailValue: '',
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({
              values = {
                emailValue: '',
              },
              handleFieldBlur,
              handleFieldChange,
              handleSubmit,
              errors,
              touched,
              ...formikProps
            }) => {
              const disableSubmitButton =
                !formikProps.isValid ||
                (!formikProps.isValidating && formikProps.isSubmitting);
              return (
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <InputField
                    fluid
                    id="emailValue"
                    name="emailValue"
                    label="Email ID"
                    value={values.emailValue}
                    errors={errors}
                    touched={touched}
                    placeholder="Enter Email"
                    onChange={handleFieldChange}
                    onBlur={handleFieldBlur}
                  />
                  <div className="cta-wrapper">
                    <Button
                      type="submit"
                      primary
                      disabled={disableSubmitButton}
                    >
                      Add Preference
                    </Button>
                  </div>
                </form>
              );
            }}
          </FormikComponent>
        </div>
      </ModalContent>
    </Modal>
  );
}

AddPopup.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  info: PropTypes.object,
};

export default AddPopup;
